import React from "react";
import { useNavigate } from "react-router-dom";
import { Upload, MapPin, X } from "lucide-react";
import { Button } from "../../components/AdminSharedComponents";

const ExcavationCreationModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleGPSUpload = () => {
    onClose();
    navigate("/admin/projects/excavation/add?tab=bulk");
  };

  const handleManualEntry = () => {
    onClose();
    navigate("/admin/projects/excavation/add?tab=manual");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-primary-dark">
            Create Excavation Point
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            Choose how you want to add excavation points:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* GPS Upload Option */}
            <div
              className="border border-gray-200 rounded-lg p-6 cursor-pointer hover:shadow-lg hover:border-blue-300 transition-all duration-200 group"
              onClick={handleGPSUpload}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
                  <Upload className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Upload GPS File
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Upload GPX/KML/CSV file from Garmin GPS device
                </p>
                <ul className="text-xs text-gray-500 space-y-1 text-left">
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                    Create multiple points at once
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                    Automatic coordinate extraction
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2"></span>
                    Perfect for field surveys
                  </li>
                </ul>
              </div>
            </div>

            {/* Manual Entry Option */}
            <div
              className="border border-gray-200 rounded-lg p-6 cursor-pointer hover:shadow-lg hover:border-green-300 transition-all duration-200 group"
              onClick={handleManualEntry}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                  <MapPin className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Manual Entry
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Create single excavation point manually
                </p>
                <ul className="text-xs text-gray-500 space-y-1 text-left">
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    Enter coordinates manually
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    Click on map to set location
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
                    Perfect for single points
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex justify-end">
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcavationCreationModal;
